// extracted by mini-css-extract-plugin
export var icon = "_ri-0";